module.exports = __webpack_public_path__ + "static/img/quadrante_mamas.fe6e864.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/quadrante_mamas.png
// module id = QI0Z
// module chunks = 1